import type { NextRouter } from 'next/router';

import * as LC from '../../constants/LocaleConstants';

const prod_canonical_url_BD = 'https://porter.com.bd';
const prod_canonical_url_UAE = 'https://porter.ae';
const prod_canonical_url_IN = 'https://porter.in';

const ga_path_bike_parcel_keyword_prefix = '/bike-parcel-delivery-';
const ga_path_trucks_prefix = '/rent-mini-trucks-in-';

export function getUrlPathString(path: string): string {
  const parts = path.split('?');
  return parts[0] ?? path;
}

export function getRoutePathList(path: string): string[] {
  const clean = getUrlPathString(path);
  return clean.split('/').slice(1);
}

export function getPillarPageName(asPath: string, index: number): string {
  return getRoutePathList(asPath)[index] ?? '';
}

export function isBrowser(): boolean {
  return typeof window !== 'undefined';
}

export function getBaseUrl(locale: string | undefined): string {
  switch (locale) {
    case LC.bn_BD:
    case LC.en_BD:
      return prod_canonical_url_BD;
    case LC.en_AE:
      return prod_canonical_url_UAE;
    case LC.en_IN:
      return prod_canonical_url_IN;
    default:
      return prod_canonical_url_UAE;
  }
}

export function getServerPath(pathname: string, asPath: string): string {
  const segments = getRoutePathList(pathname);
  const [first, second, third] = segments;

  if (first === 'bikes' && second !== undefined && third === undefined) {
    return ga_path_bike_parcel_keyword_prefix + getPillarPageName(asPath, 1);
  }
  if (first === 'trucks' && second !== undefined && third === undefined) {
    return ga_path_trucks_prefix + getPillarPageName(asPath, 1);
  }
  if (first === 'trucks' && second !== undefined && third !== undefined) {
    return (
      ga_path_trucks_prefix +
      getPillarPageName(asPath, 1) +
      '/' +
      getPillarPageName(asPath, 2)
    );
  }
  return getUrlPathString(asPath);
}

export function getCanonicalUrl(router: NextRouter): string {
  const url = getBaseUrl(router.locale);
  const path = isBrowser()
    ? getUrlPathString(router.asPath)
    : getServerPath(router.pathname, router.asPath);
  return url + path;
}
